import './Services.css';

const Services = () => {
  const services = [
    "Company Law",
    "Conveyancing & Property Law",
    "Corporate and Project Finance",
    "Banking and Securitization",
    "Bankruptcy and Receivership Matters",
    "Commercial Litigation",
    "Arbitration and other ADR Mechanisms",
    "Probate and Succession Law",
    "Intellectual Property Law",
    "Tax Law",
    "Insolvency Law"
  ];

  return (
    <section className="services">
      <h2>Our Services</h2>
      <ul className="services-list">
        {services.map((service, index) => (
          <li className="service-item" key={index}>
            <span className="service-dot" />
            <span className="service-text">{service}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Services;
